import { useEffect, useRef } from 'react';

import { useNavigationContext } from '../context/NavigationContext';

export const useAutoExpand = (hasActiveChildren: boolean, isExpanded: boolean, itemText: string) => {
  const { isNavCollapsed, toggleSection } = useNavigationContext();
  const prevIsNavCollapsed = useRef(isNavCollapsed);
  const prevHasActiveChildren = useRef(false);

  // Auto-expand when sidebar transitions from collapsed to expanded
  useEffect(() => {
    const wasCollapsed = prevIsNavCollapsed.current;
    const isNowExpanded = !isNavCollapsed;

    if (wasCollapsed && isNowExpanded && hasActiveChildren && !isExpanded) {
      toggleSection(itemText);
    }

    prevIsNavCollapsed.current = isNavCollapsed;
  }, [isNavCollapsed, hasActiveChildren, isExpanded, itemText, toggleSection]);

  // Auto-expand only when hasActiveChildren transitions from false to true
  // (navigation into this section). Does NOT re-expand if user manually collapsed.
  useEffect(() => {
    const prev = prevHasActiveChildren.current;
    prevHasActiveChildren.current = hasActiveChildren;

    if (!prev && hasActiveChildren && !isExpanded && !isNavCollapsed) {
      toggleSection(itemText);
    }
  }, [hasActiveChildren, isExpanded, isNavCollapsed, itemText, toggleSection]);
};
